export default {
  'riskControl': {
    'common': {
      'search': 'Consultar',
      'reset': 'Restablecer',
      'submit': 'Enviar',
      'cancel': 'Cancelar',
      'confirm': 'Confirmar',
      'operation': 'Operación',
      'status': 'Estado',
      'createTime': 'Hora de Creación',
      'updateTime': 'Hora de Actualización',
      'remark': 'Observación',
      'amount': 'Monto',
      'currency': 'Moneda',
      'orderNumber': 'Número de Orden',
      'memberAccount': 'Cuenta de Usuario',
      'fee': 'Comisión',
      'type': 'Tipo',
      'all': 'Todos',
      'pending': 'Pendiente',
      'processing': 'En Procesamiento',
      'completed': 'Completado',
      'failed': 'Fallido',
      'rejected': 'Rechazado',
      'approved': 'Aprobado',
      'locked': 'Bloqueado',
      'unlocked': 'Desbloqueado',
      'dateRange': 'Rango de Fechas',
      'startDate': 'Fecha de Inicio',
      'endDate': 'Fecha de Fin',
      'dateType': 'Tipo de Fecha',
      'dateType.createTime': 'Hora de Creación',
      'dateType.updateTime': 'Hora de Actualización',
      'dateType.completeTime': 'Hora de Finalización',
      'dateType.applyTime': 'Hora de Solicitud',
      'dateType.successTime': 'Hora de Éxito',
      'noData': 'Sin Datos',
      'total': 'Total {total} elementos',
    },
    'withdrawal': {
      'title': 'Control de Riesgo de Retiro',
      'search': {
        'orderNo': 'Número de Orden',
        'memberAccount': 'Cuenta de Usuario',
        'currency': 'Moneda',
        'orderStatus': 'Estado del Pedido',
        'withdrawType': 'Tipo de Retiro',
        'dateType': 'Tipo de Fecha',
        'startTime': 'Hora de Inicio',
        'endTime': 'Hora de Fin',
        'search': 'Consultar',
        'reset': 'Restablecer'
      },
      'table': {
        'orderNo': 'Número de Orden',
        'memberAccount': 'Cuenta de Usuario',
        'withdrawType': 'Tipo de Retiro',
        'withdrawInfo':'Información de la Cuenta',
        'bankAccount':'Nombre de la Cuenta Bancaria',
        'bankNumber':'Número de Tarjeta Bancaria',
        'bankName':'Nombre del Banco',
        'usdtAccount':'Dirección USDT',
        'usdtType':'Tipo de Cadena USDT',
        'usdtRate':'Tipo de Cambio USDT',
        'walletRealName':'Nombre Real de Cartera',
        'walletAccount':'Número de Cuenta de Cartera',
        'currency': 'Moneda',
        'amount': 'Monto',
        'fee': 'Comisión',
        'realAmount': 'Monto Real',
        'orderStatus': 'Estado del Pedido',
        'applyTime': 'Hora de Solicitud',
        'operation': 'Operación',
        'riskReason': 'Razón del Riesgo'
      },
      'riskReason': {
        'noDeposit': 'Sin Depósito, Usuario Oportunista',
        'bonusBothExceed': 'Bono Total y Ratio Bono-Depósito Excedidos',
        'depositWithdrawBothExceed': 'Diferencia y Porcentaje Depósito-Retiro Excedidos',
        'bonusDepositRatioExceed': 'Ratio Bono-Depósito Excedido',
        'totalBonusExceed': 'Monto Total de Bonos Excedido',
        'withdrawAmountExceed': 'Monto de Retiro Solicitado Excedido',
        'totalWinLossExceed': 'Ganancia/Pérdida Acumulada Excedida',
        'depositWithdrawPercentExceed': 'Porcentaje Depósito-Retiro Excedido',
        'depositWithdrawDiffExceed': 'Diferencia Depósito-Retiro Excedida',
        'manualReview': 'Modo de Revisión Manual',
        'suspected': 'Riesgo Sospechoso',
        'vipLevelMatch': 'Regla de coincidencia de nivel VIP marcada por riesgo',
        'gameArbitrageNoDeposit': 'Riesgo de arbitraje de juego - Regla de usuario sin depósito marcada por riesgo',
        'gameArbitrageFirstDeposit': 'Riesgo de arbitraje de juego - Regla de usuario con primer depósito marcada por riesgo',
        'gameArbitrageDeviceIp': 'Riesgo de arbitraje de juego - Regla de dispositivo/IP marcada por riesgo',
      },
      'status': {
        'pending': 'Pendiente',
        'processing': 'En Procesamiento',
        'success': 'Aprobado',
        'rejected': 'Rechazado',
        'paying': 'Pagando en Nombre del Usuario',
        'locked': 'Retiro Bloqueado',
        'riskLocked': 'Bloqueado para Revisión',
      },
      'message': {
        'fetchFailed': 'No se pudo obtener datos',
        'updateSuccess': 'Actualización Exitosa',
        'updateFailed': 'Fallo en la Actualización'
      },
      'button': {
        'approve': 'Aprobar',
        'reject': 'Rechazar',
        'lock': 'Bloquear',
        'unlock': 'Desbloquear',
        'adminUnlock': 'Desbloqueo de Administrador'
      },
      'confirm': {
        'title':'Confirmar Operación',
        'approve': '¿Está seguro de que desea aprobar este retiro?',
        'reject': '¿Está seguro de que desea rechazar este retiro?',
        'lock': '¿Está seguro de que desea bloquear este retiro?',
        'unlock': '¿Está seguro de que desea desbloquear este retiro?'
      },
      'reject': {
        'reason': 'Razón del Rechazo',
        'reasonRequired': 'Ingrese la razón del rechazo',
        'reasonPlaceholder': 'Ingrese la razón del rechazo'
      },
      'lock': {
        'reason': 'Razón del Bloqueo',
        'reasonRequired': 'Ingrese la razón del bloqueo',
        'reasonPlaceholder': 'Ingrese la razón del bloqueo'
      },
      'unlock': {
        'reason': 'Razón del Desbloqueo',
        'reasonRequired': 'Ingrese la razón del desbloqueo',
        'reasonPlaceholder': 'Ingrese la razón del desbloqueo'
      },
      'detail': {
        'title': 'Detalles del Retiro',
        'basicInfo': 'Información Básica',
        'riskInfo': 'Información del Riesgo',
        'operationLog': 'Registro de Operaciones',
        'memberInfo': 'Información del Miembro',
        'accountInfo': 'Información de la Cuenta',
        'withdrawInfo': 'Información del Retiro',
        'riskLevel': 'Nivel de Riesgo',
        'riskScore': 'Puntuación de Riesgo',
        'riskTags': 'Etiquetas de Riesgo',
        'operationTime': 'Hora de la Operación',
        'operator': 'Operador',
        'operation': 'Operación',
        'remark': 'Observación'
      }
    },
    'blacklistQuery': {
      'title': 'Consulta de Lista Negra',
      'name': 'Nombre',
      'nameRequired': 'Ingrese el nombre',
      'namePlaceholder': 'Ingrese el nombre (soporta búsqueda parcial)',
      'firstName': 'Nombre',
      'middleName': 'Nombre del Medio',
      'lastName': 'Apellido',
      'birthdate': 'Fecha de Nacimiento',
      'source': 'Origen',
      'photo': 'Foto',
      'resultTitle': 'Resultados de la Consulta',
      'queryFailedWithCode': 'Consulta fallida, código de estado: {code}',
      'queryFailed': 'Consulta fallida',
      'unavailable': 'No Disponible',
      'banned': 'Prohibido',
      'photoAlt': 'Foto'
    },
    'riskReason':{
      'suspected':'Control de riesgo sospechoso',
      'manualReview':'Modo de revisión manual',
      'depositWithdrawDiffExceed':'La Cantidad de Diferencia de Depósito-Retiro Excede',
      'depositWithdrawPercentExceed':'El Porcentaje de Depósito-Retiro Excede',
      'totalWinLossExceed':'La Ganancia/Pérdida Acumulada Excede',
      'withdrawAmountExceed':'La Cantidad de Retiro Solicitada Excede',
      'totalBonusExceed':'El Bono Total Excede',
      'bonusDepositRatioExceed':'La Razón de Depósito Preferencial Excede el Límite',
      'depositWithdrawBothExceed':'La diferencia de depósito-retiro y el porcentaje exceden el límite',
      'bonusBothExceed':'El total preferencial y las razones de depósito preferencial exceden el límite',
      'noDeposit':'Depósito de 0, usuario sin depósito',
      'vipLevelMatch': 'Regla de coincidencia de nivel VIP marcada por riesgo',
      'gameArbitrageNoDeposit': 'Riesgo de arbitraje de juego - Regla de usuario sin depósito marcada por riesgo',
      'gameArbitrageFirstDeposit': 'Riesgo de arbitraje de juego - Regla de usuario con primer depósito marcada por riesgo',
      'gameArbitrageDeviceIp': 'Riesgo de arbitraje de juego - Regla de dispositivo/IP marcada por riesgo',
    }
  }
}
